import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  contact: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));
